import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import { Strong, Text, TextLink } from '../catalyst/text'


import { Dropdown, DropdownDivider, DropdownItem, DropdownMenu } from '../catalyst/dropdown'
import * as Headless from '@headlessui/react'
import { ChevronUpDownIcon } from '@heroicons/react/16/solid'
import getUnicodeFlagIcon from 'country-flag-icons/unicode'



// TODO: replace with https://catalyst.tailwindui.com/docs/listbox example
const languages = [
  {code: "en", lang: "English", flag:getUnicodeFlagIcon("US")},
  {code: "fr", lang: "French", flag:getUnicodeFlagIcon("FR")},
  {code: "hi", lang: "Hindi", flag:getUnicodeFlagIcon("IN")},
  {code: "ar", lang: "Arabic", flag:getUnicodeFlagIcon("AE")},
];

// TODO: replace with https://catalyst.tailwindui.com/docs/listbox example
// https://github.com/piyush-eon/i18next-tutorial-yt/blob/master/src/main.jsx
// https://www.youtube.com/watch?v=dltHi9GWMIo
const LanguageSelector = () => {
  const {i18n} = useTranslation();
  console.log(i18n.resolvedLanguage)

  useEffect(() => {
    document.body.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
  }, [i18n, i18n.language]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  function getActiveLanguage() {
    return languages.find(lng => lng.code === i18n.resolvedLanguage) || languages[0];
  }

  return (


        <Dropdown>
      <Headless.MenuButton
        className="flex w-48 items-center gap-3 rounded-xl border border-transparent p-1 data-active:border-zinc-200 data-hover:border-zinc-200 dark:data-active:border-zinc-700 dark:data-hover:border-zinc-700"
        aria-label="Account options"
      >
        <span className="size-10 rounded-lg flex items-center justify-center">{getActiveLanguage().flag}</span>
        <span className="text-left flex items-center">
          <Strong className="block text-sm/5 font-medium">{getActiveLanguage().lang}</Strong>
        </span>
        <ChevronUpDownIcon className="mr-1 ml-auto size-4 shrink-0 stroke-zinc-400" />
      </Headless.MenuButton>
      <DropdownMenu className="min-w-(--button-width)">
      {languages.map((lng) => {
        return (

            <DropdownItem
            key={lng.code}
            className={lng.code === i18n.resolvedLanguage ? "" : ""}
            onClick={() => changeLanguage(lng.code)}
            >
                <span className="size-10 rounded-lg flex items-center justify-center">{lng.flag}</span>
                <span className="text-left flex items-center">
                    <span className="block text-sm/5 font-medium">{lng.lang}</span>
                </span>
            </DropdownItem>
        );
      })}
      </DropdownMenu>
    </Dropdown>




  );
};

export default LanguageSelector;